import { format } from 'svelte-i18n';

import { get } from 'svelte/store';

import {
	get_gen_2_component_channel_structure,
	hasTilt,
	isBluTRV,
	isWallDisplay,
	tmp_units_from_settings,
} from '../../../helpers/interface_helpers';

import ActionsOnEmetersV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnEmetersV2.svelte';
import ActionsOnLightsV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnLightsV2.svelte';
import ActionsOnRelaysV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnRelaysV2.svelte';
import ActionsOnRollersV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnRollersV2.svelte';
import ActionsOnTRVV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnTRVV2.svelte';
import ActionsOnPVV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnPVV2.svelte';
import ActionsOnLocksV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnLocksV2.svelte';
import ActionsOnWdThermostatV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnWDThermostat.svelte';
import ActionsOnMediaPlayer from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnMediaPlayer.svelte';
import ActionsOnDiffuser from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnDiffuser.svelte';
import ActionsOnAddons from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnAddons.svelte';
import ActionsOnCameraV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnCameraV2.svelte';
import ActionsOnFanV2 from '../SceneWizard/Process/Do/АddEditActionWizard/Steps/DeviceAction/Components/ActionsOnFanV2.svelte';

let _format = get(format);

const action_turn_states = ['on', 'off'];
const action_set_lock_states = ['day_lock', 'night_lock', 'open'];
const extended_turn_states = [...action_turn_states, 'toggle'];
const media_player_states = [
	'Radio_PlayFavourite',
	// 'Radio_Pause',//not implemented yet
	// 'Radio_Stop',//this is not needed, because MP_Stop is enough for stopping both media sources
	'MP_Play',
	'MP_Pause',
	'MP_Stop',
];

const componentsV2 = {
	relay: ActionsOnRelaysV2,
	roller: ActionsOnRollersV2,
	light: ActionsOnLightsV2,
	emeter: ActionsOnEmetersV2,
	thermostat: ActionsOnTRVV2,
	pv: ActionsOnPVV2,
	lock: ActionsOnLocksV2,
	wd_thermostat: ActionsOnWdThermostatV2,
	media_player: ActionsOnMediaPlayer,
	diffuser: ActionsOnDiffuser,
	addons: ActionsOnAddons,
	camera: ActionsOnCameraV2,
	fan: ActionsOnFanV2,
};
/**
 * extract all const in separate file
 * roller_directions is the same as in conditions
 */
const roller_directions_v2 = ['open', 'stop', 'close', 'position'];

const _ADD_ONS = (addOns) => {
	let add_ons_arr = [];
	if (addOns.switch) {
		for (const addon of addOns.switch) {
			add_ons_arr.push({
				id: 'turn_add_on',
				name: addon.name,
				add_on_ind: addon.extid,
				icon: addon.icon,
				// addon.inputType returns 'none' for now
				// disabled: addon.inputType !== 'switch',//|| (input.value !== 'ON' && input.value !== 'OFF'),
				i18tr: 'turn_add_on',
			});
		}
	}

	return add_ons_arr;
};

export const _init_device_actions_v2 = {
	pv: () => {
		return [
			{
				component: componentsV2.pv,
				actions: [
					{
						title: 'collapse_title_outputLimit',
						id: 'outputLimit',
						icon: 'fa fa-car-battery',
						i18tr: 'outputLimit',
					},
				],
			},
		];
	},
	lock: () => {
		return [
			{
				component: componentsV2.lock,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'bolt_state',
						i18tr: 'bolt_state',
						values: action_set_lock_states,
						alert: false,
					},
				],
			},
		];
	},
	module: () => {
		return [
			{
				component: componentsV2.relay,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'turn',
						i18tr: 'turn',
						values: extended_turn_states,
						alert: false,
					},
				],
			},
		];
	},
	breaker: () => {
		return [
			{
				component: componentsV2.relay,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'turn',
						i18tr: 'turn',
						values: action_turn_states,
						alert: false,
					},
				],
			},
		];
	},
	media_player: () => {
		return [
			{
				component: componentsV2.media_player,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'media',
						i18tr: 'media',
						values: media_player_states,
						alert: false,
					},
				],
			},
		];
	},
	relay: (gen) => {
		return [
			{
				component: componentsV2.relay,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'turn',
						i18tr: 'turn',
						values: extended_turn_states,
						alert:
							gen == 2
								? false
								: _format('alert_warning_required_fw_version_for_toggle', {
										default:
											'The "toggle" command for the device is supported by firmware version v1.13.0. So, please be sure the device firmware is at least v1.13.0 when you select "toggle" command.',
										values: { version: 'v1.13.0' },
									}),
					},
				],
			},
		];
	},
	roller: (gen, type, device, settings) => {
		const isMultiCover = [
			'SPSH-002PE16EU',
			'SPSH-102PE16EU',
			'S3SH-0A2P4EU',
			'S3PB-0A15194101',
		].includes(type);

		const actions: any[] = [
			{
				title: 'collapse_title_change_state',
				id: isMultiCover ? 'multi_cover_state' : 'roller state', // CHECK for rollers, must have for Shutter
				i18tr: gen === 2 ? 'opening_state' : 'roller state', //component: CheckBoxGroupElements,
				values: roller_directions_v2, //, more: 'roller'
			},
			{
				title: 'collapse_title_set_position',
				id: isMultiCover ? 'multi_cover_position' : 'roller position',
				i18tr: 'roller position',
			},
		];

		// Conditionally expose the blinds tilt position action when the cover device
		// has the slat (tilt) feature enabled — mirrors the device drawer's `hasSlat` rule.
		if (device && settings) {
			const component = get_gen_2_component_channel_structure(device);
			const hasSlatEnabled = hasTilt(device) && !!settings?.[component]?.slat?.enable;

			if (hasSlatEnabled) {
				actions.push({
					title: 'collapse_title_blinds_tilt',
					id: isMultiCover ? 'multi_cover_blinds_tilt_position' : 'blinds_tilt_position',
					i18tr: 'blinds_tilt_position',
				});
			}
		}

		return [
			{
				component: componentsV2.roller,
				actions,
			},
		];
	},
	emeter: (gen, type, addOns = {}) => {
		let main = [
			{
				component: componentsV2.emeter,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'turn',
						i18tr: 'turn',
						values: action_turn_states, //, more: 'relay'
					},
				],
			},
		];

		switch (type) {
			case 'SPEM-003CEBEU':
			case 'SPEM-003CEBEU400':
			case 'SPEM-003REBEU2000':
			case 'SPEM-003CEBEU63':
			case 'EFPEM-003CEBEU120':
				main[0].actions[0]['addOns'] = _ADD_ONS(addOns);
				main[0].actions[0]['alert'] =
					Object.keys(addOns).length === 0
						? _format('alert_cannot_control_this_device', {
								default: 'We are sorry, you can not control this device.',
							})
						: '';
				main[0].actions[0].id = 'turn_add_on';
				break;
			default:
				break;
		}

		return main;
	},
	light: (type, mode, gen, deviceMode) => {
		let main = [
			{
				component: componentsV2.light,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'turn',
						i18tr: 'turn',
						values: extended_turn_states,
						alert:
							gen == 2
								? false
								: _format('alert_warning_required_fw_version_for_toggle', {
										default:
											'The "toggle" command for the device is supported by firmware version v1.13.0. So, please be sure the device firmware is at least v1.13.0 when you select "toggle" command.',
										values: { version: 'v1.13.0' },
									}),
					},
					{
						title: 'collapse_title_brightness',
						id: 'brightness',
						i18tr: 'brightness',
					},
					...(gen >= 2
						? [
								{
									title: 'collapse_title_transition_duration',
									id: 'transition_duration',
									i18tr: 'transition_duration',
								},
							]
						: []),
				],
			},
		];
		switch (type) {
			case 'SHCL-255':
			case 'SHCB-1':
			case 'SHBLB-1':
				// if(mode === 'color'){
				//     main.push(
				//         {collapse: [{title: "Color", component: LightsActionsView, props: { id: 'color', type: 'component', component: HueSelect}, open: true, ex: false } ] }
				//     );
				// } else {
				//     main.push(
				//         {collapse: [{title: "Color temperature", component: LightsActionsView, props: { id: 'color temperature', type:'component', component: WhiteSelect}, open: true, ex: false } ] }
				//     );
				// }
				main[0].actions[0].id = 'state'; //reset turn for those kind of bulbs
				main[0].actions.push({
					title: 'collapse_title_color_white',
					id: 'set light',
					i18tr: 'set light',
				});
				break;
			case 'SHBDUO-1':
				main[0].actions[0].id = 'state'; //reset turn for those kind of bulbs
				main[0].actions.push({
					title: 'collapse_title_color_white',
					id: 'temp',
					i18tr: 'temp',
				});
				break;
			case 'SHRGBW2':
			case 'SNDC-0D4P10WW':
				if (mode === 'color' || mode === 'rgbw') {
					main[0].actions[0].id = 'state'; //reset turn for those kind of bulbs
					main[0].actions.push(
						{
							title: 'collapse_title_color_control',
							id: 'color',
							i18tr: 'color',
						},
						{
							title: 'label_white_channel',
							id: 'white_channel',
							i18tr: 'white channel',
						},
					);
				}
				if (mode === 'rgb') {
					main[0].actions[0].id = 'state'; //reset turn for those kind of bulbs
					main[0].actions.push({
						title: 'collapse_title_color_control',
						id: 'color',
						i18tr: 'color',
					});
				}
				break;
			case 'SPDC-0D5PE16EU':
				switch (deviceMode) {
					case 'rgb':
						main[0].actions[0].id = 'state';
						main[0].actions.push({
							title: 'collapse_title_color_control',
							id: 'color',
							i18tr: 'color',
						});
						break;
					case 'cct':
						main[0].actions[0].id = 'state';
						main[0].actions.push({
							title: 'collapse_title_color_white',
							id: 'temp',
							i18tr: 'temp',
						});
						break;
					default:
						break;
				}
				break;
			case 'S3BL-C010007AEU':
				main[0].actions[0].id = 'state';
				main[0].actions.push({
					title: 'collapse_title_color_white',
					id: 'set light',
					i18tr: 'set light',
					range: [2700, 6500],
				} as any);
				break;
			case 'S3BL-D010009AEU':
			case 'S3PB-04F7045601':
			case 'S3MX-0A':
				main[0].actions[0].id = 'state';
				main[0].actions.push({
					title: 'collapse_title_color_white',
					id: 'temp',
					i18tr: 'temp',
				});
				break;

			//scenes back end does not support it as I remember
			//check it and if it does, allow it
			// case 'SHBDUO-1':
			//     main.push(
			//             {  title: "Color temperature", component: LightsActionsView, props: { id: 'color temperature', component: WhiteSelect}, open: true, ex: false }
			//         )
			//     break;
			default:
				break;
		}
		return main;
	},
	thermostat: (type, settings, device) => {
		if (isBluTRV(type)) {
			return [
				{
					component: componentsV2.thermostat,
					actions: [
						{
							title: 'collapse_title_set_temperature',
							id: 'trv_target_temperature',
							i18tr: 'set_temp',
							units: tmp_units_from_settings(device),
						},
						{
							title: 'collapse_title_set_position',
							id: 'valve_percent_position',
							i18tr: 'set_position',
							units: '%',
						},
						{
							title: 'command_start_boost',
							id: 'boost',
							i18tr: 'start_boost',
							values: ['on'],
						},
						// Commented out, unavailable for now, will be added later.
						// {
						// 	title: 'collapse_title_start_boost',
						// 	id: 'boost_blu_trv',
						// 	i18tr: 'start_boost',
						// 	values: ['on'],
						// },
					],
				},
			];
		}
		if (isWallDisplay(type)) {
			return [
				{
					component: componentsV2.wd_thermostat,
					actions: [
						{
							title: 'enable_thermostat',
							id: 'temp_enable',
							i18tr: 'temp_enable',
							units: 'C',
							values: [true],
						},
						{
							title: 'disable_thermostat',
							id: 'temp_disable',
							i18tr: 'temp_enable',
							units: 'C',
							values: [false],
						},
						{
							title: 'collapse_title_set_temperature',
							id: 'set_temp',
							i18tr: 'set_temp',
							units: 'C',
						},
					],
				},
			];
		}
		return [
			{
				component: componentsV2.thermostat,
				actions: [
					{
						title: 'collapse_title_set_temperature',
						id: 'target_temp',
						i18tr: 'set_temp',
						units: tmp_units_from_settings(settings),
					},
					{
						title: 'collapse_title_change_profile',
						id: 'set_profile',
						i18tr: 'set_profile',
						values: [1, 2, 3, 4, 5],
						profiles: settings?.thermostats?.[0]?.schedule_profile_names,
					},
					{
						title: 'collapse_title_report_window_open',
						id: 'report_window_open',
						i18tr: 'report_window',
						values: ['on', 'off'],
					},
					{
						title: 'command_start_boost',
						id: 'boost',
						i18tr: 'start_boost',
						values: ['on'],
					},
				],
			},
		];
	},
	diffuser: (type) => {
		return [
			{
				component: componentsV2.diffuser,
				actions: [
					{
						title: 'collapse_title_start_boost',
						id: 'cury_boost',
						i18tr: 'start_boost',
						values: ['left', 'right'], // slot options
					},
					{
						title: 'collapse_title_control_intensity',
						id: 'cury_set',
						i18tr: 'control_intensity',
						// This will need a custom component for intensity control
					},
					// {
					// 	title: 'collapse_title_control_ambient_light',
					// 	id: 'cury_setconfig',
					// 	i18tr: 'control_ambient_light',
					// 	// This will need a custom component for ambient light config
					// },
				],
			},
		];
	},
	camera: () => {
		return [
			{
				component: componentsV2.camera,
				actions: [
					{
						title: 'collapse_title_camera_action',
						id: 'camera_action',
						i18tr: 'camera_action',
					},
				],
			},
		];
	},
	addons: (type, addOns) => {
		let alertMsg = '';
		if (!addOns?.switch?.length) {
			alertMsg = _format('alert_cannot_control_this_device', {
				default: 'We are sorry, you can not control this device.',
			});
		}
		let main = [
			{
				component: componentsV2.addons,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'turn_add_on',
						i18tr: 'turn',
						values: action_turn_states,
						addOns: _ADD_ONS(addOns),
						alert: alertMsg,
					},
				],
			},
		];

		return main;
	},
	fan: () => {
		return [
			{
				component: componentsV2.fan,
				actions: [
					{
						title: 'collapse_title_change_state',
						id: 'fan_on',
						i18tr: 'fan_on',
						values: action_turn_states,
					},
					{
						title: 'ventora_status_speed',
						id: 'fan_speed',
						i18tr: 'fan_speed',
					},
				],
			},
		];
	},
};

/**
 * Device categories that are excluded from scene "Do" actions.
 * These devices typically don't have controllable outputs (switches, relays, etc.).
 */
export const excludedCategoriesFromDoActions = ['sensor', 'inputs_reader', 'gateway', 'power_meter'];

/**
 * Specific device types that are excluded from scene "Do" actions.
 * These devices either don't have physical controls (buttons/switches)
 * or are virtual/peripheral devices that cannot perform actions.
 */
export const excludedDeviceTypesFromDoActions = [
	// 'virtual-group',
	'bthome-device', // BTHome devices are read-only sensors
	'peripheral-device', // Peripheral devices have no direct controls
	'S3EM-003CXCEU63', // 3EM-63 Gen3 - meter only, no relay
	'S4EM-003RXCEU63', // 3EM-63 Slim Gen4 - meter only, no relay
	'S4EM-001PXCEU16', // EM Mini Gen4 - meter only, no button/relay
	'S4EM-001CXCEU63', // EM-63 Gen4 - meter only, no button/relay
	'S4PB-06A7000101', // Daisy EM Gen4 - meter only, no relay
	'S4PL-00116EU', // Shelly Plug C PM Gen4 - power meter only, no relay
];

/**
 * Bypass category exclusion for specific devices
 * @type {string[]}
 */
export const includedDeviceTypesForDoActions = [
	'S3SN-0U53X', // The Pill By Shelly
	'S3BL-D010009AEU', // CCT-only device
	'S3PB-04F7045601', // CCT-only device
	'S3MX-0A', // CCT-only device
];
